import React, { useEffect, useState } from 'react';

import {
    Row,
    Col,
    FormGroup,
    Button,
    Label,
    Card,
    CardBody,
    CardTitle,
    Table
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import { useHistory } from 'react-router-dom';

import {
    createNotification,
    getNotificationList,
    deleteNotification
} from '../../services/api/api-service';

import MtSweetAlert from '../Components/MtSweetAlert';
import MtFormLayout from '../Components/MtFormLayout';


const AddNotification = () => {

    const history = useHistory();


    // ==========================================
    // FORM / ALERT STATES
    // ==========================================

    const [confirmMsg, setConfirmMsg] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);

    const [submitStatus, setSubmitStatus] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");

    const [notificationData, setNotificationData] = useState(null);


    // ==========================================
    // NOTIFICATION LIST STATES
    // ==========================================

    const [notifications, setNotifications] = useState([]);
    const [loadingNotifications, setLoadingNotifications] = useState(false);


    // ==========================================
    // DELETE STATES
    // ==========================================

    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);


    // ==========================================
    // GO BACK
    // ==========================================

    const goBack = () => {
        history.goBack();
    };


    // ==========================================
    // GET NOTIFICATIONS
    // ==========================================

    const fetchNotifications = () => {

        setLoadingNotifications(true);

        getNotificationList()
            .then((data) => {

                console.log("Notification List:", data);

                if (Array.isArray(data)) {

                    setNotifications(data);

                } else {

                    setNotifications([]);

                }

            })
            .catch((error) => {

                console.log(
                    "Error fetching notifications:",
                    error
                );

                setNotifications([]);

            })
            .finally(() => {

                setLoadingNotifications(false);

            });
    };


    // ==========================================
    // LOAD NOTIFICATIONS WHEN PAGE OPENS
    // ==========================================

    useEffect(() => {

        fetchNotifications();

    }, []);


    // ==========================================
    // FORM SUBMIT
    // ==========================================

    const handleValidSubmit = (event, values) => {

        setSubmitStatus(false);

        if (!values.msgSection || !values.msgText) {

            setSubmitStatus(true);

            setAlertMsg(
                "Please enter notification title and message"
            );

            return;
        }


        const dataValue = {

            msgSection: values.msgSection,

            msgText: values.msgText,

            language: values.language || "English",

            date: new Date(),

            status: "read"

        };


        console.log(
            "Notification Data:",
            dataValue
        );


        setNotificationData(dataValue);

        setConfirmMsg(true);
    };


    // ==========================================
    // CONFIRM AND SAVE NOTIFICATION
    // ==========================================

    const submitHandler = () => {

        if (!notificationData) {
            return;
        }


        createNotification(notificationData)

            .then((result) => {

                console.log(
                    "Notification Created:",
                    result
                );


                // Close confirmation
                setConfirmMsg(false);


                // Refresh notification list
                fetchNotifications();


                // Show success message
                setSuccessMsg(true);


                // Clear notification data
                setNotificationData(null);

            })

            .catch((error) => {

                console.log(
                    "Error creating notification:",
                    error
                );


                setConfirmMsg(false);

                setSubmitStatus(true);

                setAlertMsg(
                    "Something went wrong while creating notification"
                );

            });
    };


    // ==========================================
    // DELETE BUTTON CLICK
    // ==========================================

    const handleDeleteClick = (notification) => {

        console.log(
            "Selected notification for delete:",
            notification
        );


        setSelectedNotification(notification);

        setDeleteConfirm(true);
    };


    // ==========================================
    // CONFIRM DELETE
    // ==========================================

    const confirmDelete = () => {

        if (!selectedNotification) {
            return;
        }


        const notificationId =
            selectedNotification.id ||
            selectedNotification._id;


        if (!notificationId) {

            console.log(
                "Notification ID not found:",
                selectedNotification
            );

            setDeleteConfirm(false);

            setSubmitStatus(true);

            setAlertMsg(
                "Notification ID not found"
            );

            return;
        }


        console.log(
            "Deleting notification:",
            notificationId
        );


        deleteNotification(notificationId)

            .then((result) => {

                console.log(
                    "Notification Deleted:",
                    result
                );


                // Close delete confirmation
                setDeleteConfirm(false);


                // Clear selected notification
                setSelectedNotification(null);


                // Refresh list
                fetchNotifications();

            })

            .catch((error) => {

                console.log(
                    "Error deleting notification:",
                    error
                );


                setDeleteConfirm(false);

                setSelectedNotification(null);

                setSubmitStatus(true);

                setAlertMsg(
                    "Something went wrong while deleting notification"
                );

            });
    };


    // ==========================================
    // FORMAT DATE
    // ==========================================

    const formatDate = (date) => {

        if (!date) {
            return "-";
        }


        try {

            return new Date(date).toLocaleString();

        } catch (error) {

            return "-";

        }
    };


    // ==========================================
    // RENDER
    // ==========================================

    return (

        <React.Fragment>


            {/* ==========================================
                ADD NOTIFICATION
            ========================================== */}

            <MtFormLayout

                breadcrumbsTitle="Notification"

                breadcrumbItem="Add Notification"

                title="Add Notification"

                subTitle="Create notification for mobile app users"

            >


                <AvForm

                    className="needs-validation"

                    onValidSubmit={handleValidSubmit}

                >


                    <Row>


                        {/* ==========================================
                            NOTIFICATION TITLE
                        ========================================== */}

                        <Col md="12">

                            <FormGroup>

                                <Label>
                                    Notification Title
                                </Label>


                                <AvField

                                    name="msgSection"

                                    placeholder="Enter notification title"

                                    type="text"

                                    errorMessage="Enter Notification Title"

                                    className="form-control"

                                    validate={{
                                        required: {
                                            value: true
                                        }
                                    }}

                                />

                            </FormGroup>

                        </Col>



                        {/* ==========================================
                            NOTIFICATION MESSAGE
                        ========================================== */}

                        <Col md="12">

                            <FormGroup>

                                <Label>
                                    Notification Message
                                </Label>


                                <AvField

                                    name="msgText"

                                    placeholder="Enter notification message"

                                    type="textarea"

                                    rows="5"

                                    errorMessage="Enter Notification Message"

                                    className="form-control"

                                    validate={{
                                        required: {
                                            value: true
                                        }
                                    }}

                                />

                            </FormGroup>

                        </Col>



                        {/* ==========================================
                            LANGUAGE
                        ========================================== */}

                        <Col md="6">

                            <FormGroup>

                                <Label>
                                    Language
                                </Label>


                                <AvField

                                    name="language"

                                    type="select"

                                    className="form-control"

                                >

                                    <option value="English">
                                        English
                                    </option>


                                    <option value="Hindi">
                                        Hindi
                                    </option>

                                </AvField>

                            </FormGroup>

                        </Col>



                        {/* ==========================================
                            ERROR MESSAGE
                        ========================================== */}

                        {submitStatus && (

                            <Col md="12">

                                <div

                                    className="alert alert-danger fade show"

                                    role="alert"

                                >

                                    {alertMsg}

                                </div>

                            </Col>

                        )}

                    </Row>



                    {/* ==========================================
                        SUBMIT BUTTON
                    ========================================== */}

                    <Button

                        color="success"

                        type="submit"

                    >

                        Submit

                    </Button>


                </AvForm>



                {/* ==========================================
                    NOTIFICATION DATA
                ========================================== */}

                <Row className="mt-4">

                    <Col md="12">


                        <Card>


                            <CardBody>


                                <CardTitle className="mb-4">

                                    Notification Data

                                </CardTitle>



                                {/* ==========================================
                                    LOADING
                                ========================================== */}

                                {loadingNotifications ? (

                                    <div className="text-center">

                                        Loading notifications...

                                    </div>

                                ) : notifications.length === 0 ? (


                                    /* ==========================================
                                        NO DATA
                                    ========================================== */

                                    <div className="text-center text-muted">

                                        No notifications found.

                                    </div>


                                ) : (


                                    /* ==========================================
                                        NOTIFICATION TABLE
                                    ========================================== */

                                    <div className="table-responsive">


                                        <Table

                                            className="table table-bordered table-hover"

                                        >


                                            <thead>

                                                <tr>

                                                    <th>
                                                        #
                                                    </th>

                                                    <th>
                                                        Title
                                                    </th>

                                                    <th>
                                                        Message
                                                    </th>

                                                    <th>
                                                        Language
                                                    </th>

                                                    <th>
                                                        Date
                                                    </th>

                                                    <th>
                                                        Action
                                                    </th>

                                                </tr>

                                            </thead>



                                            <tbody>


                                                {notifications.map(
                                                    (notification, index) => (

                                                        <tr

                                                            key={
                                                                notification.id ||
                                                                notification._id ||
                                                                index
                                                            }

                                                        >


                                                            {/* Number */}

                                                            <td>

                                                                {index + 1}

                                                            </td>



                                                            {/* Title */}

                                                            <td>

                                                                <strong>

                                                                    {
                                                                        notification.msgSection
                                                                    }

                                                                </strong>

                                                            </td>



                                                            {/* Message */}

                                                            <td>

                                                                {
                                                                    notification.msgText
                                                                }

                                                            </td>



                                                            {/* Language */}

                                                            <td>

                                                                {
                                                                    notification.language ||
                                                                    "English"
                                                                }

                                                            </td>



                                                            {/* Date */}

                                                            <td>

                                                                {
                                                                    formatDate(
                                                                        notification.date ||
                                                                        notification.createdAt
                                                                    )
                                                                }

                                                            </td>



                                                            {/* Delete */}

                                                            <td>

                                                                <Button

                                                                    color="danger"

                                                                    size="sm"

                                                                    onClick={() =>
                                                                        handleDeleteClick(
                                                                            notification
                                                                        )
                                                                    }

                                                                >

                                                                    Delete

                                                                </Button>

                                                            </td>


                                                        </tr>

                                                    )
                                                )}


                                            </tbody>


                                        </Table>


                                    </div>

                                )}


                            </CardBody>


                        </Card>


                    </Col>

                </Row>


            </MtFormLayout>



            {/* ==========================================
                ADD NOTIFICATION CONFIRMATION
            ========================================== */}

            {confirmMsg ? (

                <MtSweetAlert

                    alertTitle="Add Notification"

                    alertConfirmBtnText="Submit"

                    alertHandler={submitHandler}

                >

                    Do You Want To Submit Notification?

                </MtSweetAlert>

            ) : null}



            {/* ==========================================
                SUCCESS MESSAGE
            ========================================== */}

            {successMsg ? (

                <MtSweetAlert

                    alertTitle="Notification"

                    alertConfirmBtnText="OK"

                    alertHandler={() => {

                        setSuccessMsg(false);

                    }}

                >

                    Notification Added Successfully

                </MtSweetAlert>

            ) : null}



            {/* ==========================================
                DELETE CONFIRMATION
            ========================================== */}

            {deleteConfirm ? (

                <MtSweetAlert

                    alertTitle="Delete Notification"

                    alertConfirmBtnText="Delete"

                    alertHandler={confirmDelete}

                >

                    Do You Want To Delete This Notification?

                </MtSweetAlert>

            ) : null}


        </React.Fragment>

    );

};


export default AddNotification;

